import en from './en';
import kn from './kn';
import or from './or';
import hi from './hi';
import { locale, type LocaleCode } from './locale.svelte';
import type { MessageKey } from './en';

export type { LocaleCode } from './locale.svelte';

export const LOCALES: { code: LocaleCode; labelKey: MessageKey }[] = [
  { code: 'en', labelKey: 'lang.english' },
  { code: 'kn', labelKey: 'lang.kannada' },
  { code: 'or', labelKey: 'lang.odia' },
  { code: 'hi', labelKey: 'lang.hindi' }
];

const dicts: Record<LocaleCode, Record<string, string>> = { en, kn, or, hi };

export { locale } from './locale.svelte';

export function t(key: MessageKey, vars?: Record<string, string | number>): string {
  // Touch reactive locale so Svelte re-renders when language changes.
  const code = locale.current;
  let str = dicts[code]?.[key as string] ?? (en as Record<string, string>)[key] ?? key;
  if (vars) {
    for (const [k, v] of Object.entries(vars)) {
      str = str.replace(new RegExp(`\\{${k}\\}`, 'g'), String(v));
    }
  }
  return str;
}
